import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { useConfiguration } from '../../context/configurationContext';
import { isScrollingDisabled } from '../../ducks/ui.duck';
import { getMarketplaceEntities } from '../../ducks/marketplaceData.duck';
import { createSlug } from '../../util/urlHelpers';
import { buildStoreCanonicalUrl } from '../../util/seo';

import { LayoutSingleColumn, Page } from '../../components';
import TopbarContainer from '../TopbarContainer/TopbarContainer';
import FooterContainer from '../FooterContainer/FooterContainer';

const RESULTS_PER_PAGE = 20;

const buildListingUrl = listing => {
  const title = listing.attributes?.title || '';
  const slug = createSlug(title);
  const id = listing.id?.uuid;
  return `/rentals/${slug}/${id}`;
};

const buildCurrentPageUrl = params => {
  const { citySlug, storeSlug, userId } = params;
  return citySlug
    ? `/rental-owner/${citySlug}/${storeSlug}/${userId}/listings`
    : `/rental-owner/${storeSlug}/${userId}/listings`;
};

const StoreListingsPageComponent = props => {
  const {
    listings,
    pagination,
    storeUser,
    fetchInProgress,
    fetchError,
    scrollingDisabled,
    params,
  } = props;

  console.log('hereee')

  const config = useConfiguration();
  const rootUrl = config.marketplaceRootURL || '';
  const marketplaceName = config.marketplaceName || '';

  const storeName =
    storeUser?.attributes?.profile?.publicData?.storeName ||
    storeUser?.attributes?.profile?.displayName ||
    '';
  const city = storeUser?.attributes?.profile?.publicData?.city || null;
  const userId = params.userId;

  const storeUrl = buildStoreCanonicalUrl({
    rootUrl: '',
    storeName,
    city,
    userId,
    activeTab: null,
  });

  const currentPageUrl = buildCurrentPageUrl(params);
  const page = pagination?.page || 1;
  const totalPages = pagination?.totalPages || 1;
  const totalItems = pagination?.totalItems || 0;

  const pageTitle = `Listings by ${storeName} | ${marketplaceName}`;

  // JSON-LD schema
  const schema = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'Store',
        '@id': `${rootUrl}${storeUrl}#store`,
        name: storeName,
        url: `${rootUrl}${storeUrl}`,
      },
      {
        '@type': 'ItemList',
        name: `Listings by ${storeName}`,
        url: `${rootUrl}${currentPageUrl}`,
        numberOfItems: totalItems,
        itemListElement: (listings || []).map((listing, index) => {
          const listingUrl = buildListingUrl(listing);
          return {
            '@type': 'ListItem',
            position: (page - 1) * RESULTS_PER_PAGE + index + 1,
            url: `${rootUrl}${listingUrl}`,
            name: listing.attributes?.title || '',
          };
        }),
      },
    ],
  };

  return (
    <Page
      title={pageTitle}
      scrollingDisabled={scrollingDisabled}
      schema={schema}
    >
      <LayoutSingleColumn
        topbar={<TopbarContainer />}
        footer={<FooterContainer />}
      >
        <div style={{ maxWidth: '960px', margin: '0 auto', padding: '24px 16px' }}>
          <h1>Listings by {storeName}</h1>

          {fetchInProgress ? (
            <p>Loading listings…</p>
          ) : fetchError ? (
            <p>Something went wrong. Please try again later.</p>
          ) : (
            <>
              <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                {(listings || []).map(listing => {
                  const listingUrl = buildListingUrl(listing);
                  const title = listing.attributes?.title || 'Untitled';
                  return (
                    <li key={listing.id.uuid} style={{ marginBottom: '12px' }}>
                      <a href={listingUrl}>{title}</a>
                    </li>
                  );
                })}
              </ul>

              {(listings || []).length === 0 && (
                <p>No listings found.</p>
              )}

              <nav style={{ marginTop: '24px' }}>
                {page > 1 && (
                  <a
                    href={`${currentPageUrl}?page=${page - 1}`}
                    style={{ marginRight: '16px' }}
                  >
                    Previous
                  </a>
                )}
                {page < totalPages && (
                  <a href={`${currentPageUrl}?page=${page + 1}`}>
                    Next
                  </a>
                )}
              </nav>
            </>
          )}
        </div>
      </LayoutSingleColumn>
    </Page>
  );
};

const mapStateToProps = state => {
  const {
    userId,
    listingRefs,
    pagination,
    fetchListingsInProgress,
    fetchListingsError,
  } = state.StoreListingsPage;

  const listings = getMarketplaceEntities(state, listingRefs);

  const userRef = userId
    ? [{ type: 'user', id: userId }]
    : [];
  const userMatches = getMarketplaceEntities(state, userRef);
  const storeUser = userMatches.length === 1 ? userMatches[0] : null;

  return {
    listings,
    pagination,
    storeUser,
    fetchInProgress: fetchListingsInProgress,
    fetchError: fetchListingsError,
    scrollingDisabled: isScrollingDisabled(state),
  };
};

const StoreListingsPage = compose(
  connect(mapStateToProps),
  withRouter
)(StoreListingsPageComponent);

export default StoreListingsPage;
